import { Trans } from "react-i18next";
import { useLinkAccount } from "../hooks/useLinkAccount";
import { LinkAccountIllustration } from "./LinkAccountIllustration";

export const AddLinkAccount = () => {
  const go2Link = useLinkAccount();

  return (
    <div className="flex h-full min-h-0 flex-col gap-[16px] py-[24px]">
      <div className="text-[16px] font-semibold px-[24px]">
        <Trans>Linked Accounts</Trans>
      </div>
      <LinkAccountIllustration className="min-h-[360px]" onConnect={go2Link} loading={go2Link.isPending()} />
    </div>
  );
};
